const PATHS = {
    HOME: "/",
    PAYMENT: "/payment",
    PAYMENT_SUCCESS: "/payment/success"
}

export default PATHS;